export default __webpack_public_path__ + "static/media/coworking.active.b9c4a0da.svg";